<template>
  <MapRoutesMultipleV2 slot="map"
                       ref="mapRoute"
                       :height="'540px'"
                       :width="'100%'"
                       :locations="routes"
                       :lat="lat"
                       :lng="lng"
                       @input="handleChange">
  </MapRoutesMultipleV2>
</template>
<script>
/* eslint-disable */
import MapRoutesMultipleV2 from '../maps/MapRoutesMultipleV2.vue';
import { tenantCentroid } from '@/mixins/tenants';

export default {
  name: 'MultiRouteMap',
  components: {
    MapRoutesMultipleV2,
  },
  props: {
    routes:{
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      lat: -33.6001323,
      lng: -71.8600872,
      routesIntervalMode: 2,
      selectedRoutes: [],
    };
  },
  created() {
    const position = tenantCentroid();
    this.lat = position.lat;
    this.lng = position.lng;
  },
  methods: {
    handleChange(value){
      this.selectedRoutes = [];
      this.$emit('input',value);
    },
    selectRoute(routeId) {
      this.$refs.mapRoute.selectRoute(routeId);
    },
    reRenderMap() {
      this.$refs.mapRoute.reRenderMap();
    }
  },
  computed: {
  },
};
</script>

<style scoped>
</style>
